import { cacheKeys } from "@constants/cache-keys";
import { isScreenshotMode } from "@constants/common";
import { isMockedData } from "@constants/demo";
import { mockedUserLeaderboard } from "@constants/mocked-data";
import useAppConfigIds from "@hooks/useAppConfigIds";
import useClerkUser from "@hooks/useClerkUser";
import { useQuery } from "@tanstack/react-query";
import { type PeriodType, fetchUserRank } from "../api";

const useUserLeaderboard = (scope: PeriodType) => {
	const { projectId, organizationId } = useAppConfigIds();
	const { userPublicMetadataId } = useClerkUser();

	const { data: response } = useQuery({
		queryKey: [cacheKeys.userLeaderboard, scope],
		queryFn: () =>
			isScreenshotMode
				? mockedUserLeaderboard
				: fetchUserRank({
						periodType: scope,
						projectId,
						organizationId,
						userId: userPublicMetadataId,
					}),
		enabled:
			isMockedData ||
			(!!projectId && !!organizationId && !!userPublicMetadataId),
	});

	return {
		userLeaderboardResponse: response,
	};
};

export default useUserLeaderboard;
